<template>
    <psi-form-layout-section
        title="Update Photo"
        icon="mdi-camera"
        btn-label="Save Photo"
        btn-icon="mdi-camera"
        :btn-disabled="image === null"
        :loading="dataLoading"
        @section-save="save"
    >
        <div class="d-flex mb-4 align-center">
            <h3>Update Profile Photo</h3>
            <v-spacer></v-spacer>
            <v-btn-toggle
                v-model="toggle"
                mandatory
                color="primary darken-2"
                ref="btn-toggle"
            >
                <v-btn>
                    Edit Photo
                    <v-icon class="ml-2">mdi-camera</v-icon>
                </v-btn>
                <v-btn>
                    View Photo
                    <v-icon class="ml-2">mdi-account-eye</v-icon>
                </v-btn>
            </v-btn-toggle>
        </div>

        <div class="text-center">
            <v-image-input
                v-if="editing"
                v-model="image"
                :image-quality="0.85"
                clearable
                image-format="jpeg"
                @file-info="onFileInfo"
            />
            <v-card max-width="250" class="mx-auto" rounded="lg">
                <v-img
                    v-if="viewing"
                    :src="user.large_profile_photo_url"
                    max-height="250"
                    max-width="250"
                >
                </v-img>
            </v-card>
        </div>
    </psi-form-layout-section>
</template>
<script>
import VImageInput from "vuetify-image-input";
const MODE_EDIT = 0;
const MODE_VIEW = 1;
export default {
    name: "upload-photo",
    components: {
        VImageInput,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        dataLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            toggle: MODE_EDIT,
            image: null,
            fileInfo: {},
        };
    },
    computed: {
        editing() {
            return this.toggle === MODE_EDIT;
        },
        viewing() {
            return this.toggle === MODE_VIEW;
        },
    },
    methods: {
        onFileInfo(fileInfo) {
            this.fileInfo = fileInfo;
        },
        save() {
            this.$emit("update", this.user.id, {
                image: this.image,
            });
        },
    },
};
</script>

<style scoped>
</style>